/**
 * Utility: Create a guideline object with default values
 * @param {string} name - unique identifier for the guideline
 * @param {boolean} isActive - whether the guideline is currently active
 * @param {boolean} isBlinking - whether the guideline should blink
 */
const createGuideline = (name, isActive = false, isBlinking = true, placement = "bottom") => ({
  name,
  isActive,
  isBlinking,
  placement
});

/**
 * Non-NZLO Guidelines
 * - First guideline ("select-template") starts active and not blinking
 * - Remaining guidelines start inactive and blinking
 */
export const nonNZLOGuidelines = [
  createGuideline("select-template", true, false, "top"),
  createGuideline("attach-image"),
  createGuideline("tips-for-writing"),
  createGuideline("preview-send"),
];

/**
 * NZLO Guidelines
 * - Similar to non-NZLO but includes "add-bible-verse"
 */
export const NZLOGuidelines = [
  createGuideline("select-template", true, false, "top"),
  createGuideline("attach-image"),
  createGuideline("add-bible-verse"),
  createGuideline("tips-for-writing"),
];

/**
 * Utility: Safely get guidelines from localStorage
 * @param {string} guidelineKey - storage key
 * @returns {Array|null} parsed guidelines or null if not found
 */
export const getGuidelinesFromStorage = (guidelineKey) => {
  try {
    const value = localStorage.getItem(guidelineKey);
    return value ? JSON.parse(value) : null;
  } catch {
    return null; // fail silently if parsing fails
  }
};

/**
 * Utility: Safely set guidelines to localStorage
 * @param {string} guidelineKey - storage key
 * @param {Array} guidelines - guidelines array to store
 */
export const setGuidelinesToStorage = (guidelineKey, guidelines) => {
  try {
    localStorage.setItem(guidelineKey, JSON.stringify(guidelines));
  } catch {
    // fail silently if saving fails
  }
};
